import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import Web3 from 'web3'
import { useWallet } from 'use-wallet'

import Container from 'components/Container'
import AccountButton from './components/AccountButton'
import GetTokenButton from './components/GetTokenButton'

import logo from 'assets/img/dice.png'

const useQuery = (history) => {
  return new URLSearchParams(history?.location?.search)
}

const TopBar = () => {
  const { ethereum } = useWallet()
  const history = useHistory()
  const query = useQuery(history)
  const handleGoHome = () => {
    history.push('/')
  }

  useEffect(() => {
    const referrerQuery = query.get('r')
    if (referrerQuery) {
      const web3 = new Web3(ethereum)
      if (!web3.utils.isAddress(referrerQuery)) {
        return undefined
      }
      localStorage.setItem('referrer', referrerQuery)
    }
  }, [query])

  return (
    <StyledTopBar>
      <Container size="lg">
        <StyledTopBarInner>
          <StyledAccountButtonWrapper onClick={handleGoHome}>
            <Logo src={logo} />
            <StyledLogoTitle>You Bet! Launch</StyledLogoTitle>
          </StyledAccountButtonWrapper>
          <StyledAccountButtonWrapper>
            <GetTokenButton text="Get UBET Token" />
            <GetTokenButton
              text="You Bet! Raffles"
              href="http://app.youbet.tech/"
            />
            <AccountButton />
          </StyledAccountButtonWrapper>
        </StyledTopBarInner>
      </Container>
    </StyledTopBar>
  )
}

const StyledTopBar = styled.div``

const Logo = styled.img`
  width: 55px;
`

const StyledLogoTitle = styled.div`
  font-size: 28px;
  font-weight: bold;
  margin-left: 10px;
  color: ${(props) => props.theme.color.grey[600]};
  font-family: 'Kaushan Script', sans-serif;
`

const StyledTopBarInner = styled.div`
  align-items: center;
  display: flex;
  height: ${(props) => props.theme.topBarSize}px;
  justify-content: space-between;
  max-width: ${(props) => props.theme.siteWidth}px;
  width: 100%;
`

const StyledAccountButtonWrapper = styled.div`
  background-color: transparent;
  border: none;
  outline: none !important;
  text-decoration: none;
  align-items: center;
  display: flex;
  cursor: pointer;
  justify-content: flex-end;
  @media (max-width: 400px) {
    justify-content: center;
    width: auto;
  }
`

export default TopBar
